import { useState, useEffect } from 'react'
import { Box, CircularProgress, IconButton, Typography } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { ISmartTableFooter, Row } from './SmartTableDefinitions'

interface P {
    isLoading: boolean
    footer: ISmartTableFooter
    rows: Row[]
    hidePagination
}

export default function TableFooter({ isLoading, footer, rows, hidePagination }: P) {
    const { currentPage, hasNextPage, batchSize } = footer
    const [page, setPage] = useState(currentPage ?? 1)

    useEffect(() => {
        if (currentPage !== undefined) {
            setPage(currentPage)
        }
    }, [currentPage])

    const handlePrevious = () => {
        if (page > 1) {
            const newPage = page - 1
            setPage(newPage)
            footer?.onPageChange?.(newPage)
        }
    }

    const handleNext = () => {
        if (hasNextPage) {
            const newPage = page + 1
            setPage(newPage)
            footer?.onPageChange?.(newPage)
        }
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', m: 3, ml: 4, mr: 4 }}>
            {!hidePagination && (
                <>
                    {isLoading
                        ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <Typography variant='body2'>
                                        Loading Rows...
                                    </Typography>
                                    <CircularProgress size={20} />
                                </Box>
                            )
                        : (
                                <Typography variant='body2'>
                                    Rows: {rows?.length ?? 0}/{batchSize}
                                </Typography>
                            )}

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <IconButton
                            onClick={handlePrevious}
                            disabled={isLoading || page === 1}
                            size='small'>
                            <ChevronLeft />
                        </IconButton>

                        <Typography variant='body2'>
                            Page {page}
                        </Typography>

                        <IconButton
                            onClick={handleNext}
                            disabled={isLoading || !hasNextPage}
                            size='small'>
                            <ChevronRight />
                        </IconButton>
                    </Box>

                </>
            )}

        </Box>

    )
}
